import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import common from 'ui-react-common';
import _ from 'lodash';
import config from './../../../config';
import api from './../../../services/CoreAPI';
import * as validations from './validations';

const { Select, InputField, GoogleAddressInput } = common.ui.components.forms;
const { Stack, Link } = common.ui.components;
const Alert = common.ui.components.Alert;
const { ScriptLoader, scripts } = common.ui.components.scriptLoader;
const { wrapComponentWithProvider } = common.ui.containers.root;
const {
    googleAddressActions,
    googleAddressSelectors,
    googleAddressVerifyStore,
} = common.ui.components;

export class Address extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGooglePlacesLoaded: false,
        };
    }

    handleScriptLoaded() {
        this.setState({
            isGooglePlacesLoaded: this.googlePlacesLoaded(),
        });
    }

    googlePlacesLoaded() {
        return _.hasIn(window, 'google.maps.places');
    }

    displayGoogleAddress() {
        const { setShouldDisplayGA, setAPIFailure } = this.props;
        setShouldDisplayGA(true);
        setAPIFailure(false);
    }

    renderGoogleAddress() {
        const { selectedAddress = {} } = this.props;
        return (
            <Stack id="googleAddressFields" splitAt="tiny">
                <Stack.Item breakpoint="tiny" width="half">
                    <GoogleAddressInput
                        name="googleAddress"
                        placeHolder="Current Home Address"
                        validation={validations.googleAddressValidation}
                        selectedAddress={selectedAddress}
                        helper="Please enter the physical address associated with your utilities and credit
            accounts."
                    />
                </Stack.Item>
                <Stack.Item breakpoint="tiny" width="half">
                    <InputField
                        id="aptNumber"
                        name="aptNumber"
                        type="text"
                        placeholder="Apt, Suite, Unit, etc."
                        validation={validations.aptNumberValidation}
                    />
                </Stack.Item>
            </Stack>
        );
    }

    renderAddressFields() {
        const {
            hasSeenError,
            isFailureState,
            streetAddress,
            city,
            state,
            zip,
        } = this.props;
        return (
            <Fragment>
                {isFailureState && (
                    <Stack>
                        <Stack.Item breakpoint="tiny">
                            <Alert type="info" isDisplayed>
                Our search couldn&#39;t find your address? Please enter it
                below.
                            </Alert>
                        </Stack.Item>
                    </Stack>
                )}
                <Stack id="addressFields" splitAt="tiny">
                    <Stack.Item breakpoint="tiny" width="half">
                        <InputField
                            id="streetAddress"
                            name="streetAddress"
                            type="text"
                            placeholder="Current Home Address"
                            validation={validations.addressValidation}
                            value={streetAddress}
                            helper="Please enter the physical address associated with your utilities and credit
              accounts."
                        />
                        {hasSeenError && (
                            <p className="subtext address-fallback">
                                <span>
                                    <Link onClick={() => this.displayGoogleAddress()}>
                    Want to search for your address?
                                    </Link>
                                </span>
                            </p>
                        )}
                    </Stack.Item>
                    <Stack.Item
                        breakpoint="tiny"
                        width="half"
                        className="sprk-o-Stack sprk-o-Stack--split@xxs"
                    >
                        <Stack.Item breakpoint="min" width="third">
                            <InputField
                                id="city"
                                name="city"
                                type="text"
                                placeholder="City"
                                validation={validations.cityValidation}
                                value={city}
                            />
                        </Stack.Item>
                        <Stack.Item breakpoint="min" width="third">
                            <Select
                                id="state"
                                name="state"
                                type="text"
                                placeholder="State"
                                options={config.global.states.map((i) => ({ text: i, value: i }))}
                                validation={validations.stateValidation}
                                value={state}
                            />
                        </Stack.Item>
                        <Stack.Item breakpoint="min" width="third">
                            <InputField
                                id="zip"
                                name="zip"
                                type="number"
                                maxLength="5"
                                placeholder="Zip"
                                validation={validations.zipValidation}
                                value={zip}
                            />
                        </Stack.Item>
                    </Stack.Item>
                </Stack>
            </Fragment>
        );
    }

    render() {
        const { isGooglePlacesLoaded } = this.state;
        const { useAddressFields, shouldDisplayGA, isFailureState } = this.props;
        return (
            <Fragment>
                {!useAddressFields
        && isGooglePlacesLoaded
        && shouldDisplayGA
        && !isFailureState
                    ? this.renderGoogleAddress()
                    : this.renderAddressFields()}
                {!useAddressFields && (
                    <ScriptLoader
                        scriptName={scripts.googleAddressAutocompleteUi}
                        api={api}
                        scriptLoaded={() => this.handleScriptLoaded()}
                        apiKey={config.googleMapsKey}
                    />
                )}
            </Fragment>
        );
    }
}

Address.defaultProps = {
    setAPIFailure: () => {},
    shouldDisplayGA: true,
    hasSeenError: false,
    isFailureState: false,
    useAddressFields: false,
};

Address.propTypes = {
    setShouldDisplayGA: PropTypes.func.isRequired,
    setAPIFailure: PropTypes.func,
    useAddressFields: PropTypes.bool,
    shouldDisplayGA: PropTypes.bool,
    hasSeenError: PropTypes.bool,
    isFailureState: PropTypes.bool,
    streetAddress: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
};

const mapStateToProps = (state) => ({
    shouldDisplayGA: googleAddressSelectors.getShouldDisplayComponent(state),
    hasSeenError: googleAddressSelectors.getHasSeenError(state),
    isFailureState: googleAddressSelectors.getApiFailureState(state),
    selectedAddress: googleAddressSelectors.getSelectedAddress(state),
});

const mapDispatchToProps = (dispatch) => ({
    setAPIFailure: (hasFailure) =>
        dispatch(googleAddressActions.setApiFailureState(hasFailure)),
    setShouldDisplayGA: (shouldDisplay) =>
        dispatch(googleAddressActions.setShouldDisplayComponent(shouldDisplay)),
});

export const ConnectedAddress = connect(
    mapStateToProps,
    mapDispatchToProps
)(Address);

export default wrapComponentWithProvider(
    ConnectedAddress,
    googleAddressVerifyStore
);
